<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <bubbles-background></bubbles-background>
        <div class="container container-lg shape-container pb-4">
          <card shadow class="card-profile mt-4 border-0" no-body>
            <card-header title="Text Classification" :icon="{prefix:'fas', iconName: 'comments'}" prefix="fas"
                         :text="pageText"></card-header>
            <div class="px-4 pb-3">
              <div v-if="classifications"></div>
              <ptwist-loading v-else-if="loading"></ptwist-loading>
              <server-error v-else-if="error"></server-error>
              <no-data-error v-else></no-data-error>
            </div>
          </card>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

// import { Bus } from '../bus'
import { getInfoText } from '../info'

export default {
  name: 'text-classification',
  components: {},
  data: () => ({
    loading: true,
    collection: 'plastic_pollution',
    language: 'en',
    wordcloudType: 'terms',
    pageText: getInfoText('wordclouds'),
    timestamps: null,
    classifications: null
  }),
  computed: {},
  methods: {},
  // watch: {
  //   timestamps () {
  //     this.updateWordcloud()
  //   },
  //   collection () {
  //     this.updateWordcloud()
  //   },
  //   language () {
  //     this.updateWordcloud()
  //   }
  // },
  created () {
    // Bus.$on('new-language', function (newLanguage) {
    //   this.language = newLanguage
    //   Bus.$emit('new-collections', this.language)
    // }.bind(this))
    // Bus.$on('new-collection', function (newCollection) {
    //   this.collection = newCollection
    // }.bind(this))
    // Bus.$on('daterange-update', function (timestamps) {
    //   this.timestamps = timestamps
    // }.bind(this))
  }

}
</script>
<style lang="sass">

</style>
